// FTEDN Team — Stats Card (with brand accent colors)
import './StatsCard.css';

interface StatsCardProps {
  label: string;
  value: string;
  icon: string;
  accent?: 'sage' | 'navy' | 'lime';
}

export function StatsCard({ label, value, icon, accent = 'sage' }: StatsCardProps) {
  return (
    <div className={`stats-card stats-card--${accent}`}>
      <div className="stats-card-header">
        <span className="stats-icon">{icon}</span>
      </div>
      <div className="stats-value">{value}</div>
      <div className="stats-label">{label}</div>
    </div>
  );
}
